<template>
  <!-- <div id="modal" class="modal estimate_modal parent_div" v-show="modalShown"> -->
  <div id="modal" class="editmodal" v-show="modalShown" v-bind:style="{top: top + 'px', left: left + 'px'}">
    <!-- <div class="modal-main wrapper" id="estimate_main"> -->
    <div>
      <input type="text" v-model="textVal">
    </div>
    <button @click="save">保存する</button>
    <button @click="cancel">キャンセル</button>
  </div>
</template>
<script>
export default {
  name: 'InputModal',
  props: {
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    onCancel: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    },
    showSuccess: {
      type: Function,
      default: function () {}
    },
    defaultText: {
      type: String,
      default: ''
    },
    top: {
      default: 0,
      type: Number
    },
    left: {
      default: 0,
      type: Number
    }
  },
  components: {
  },
  data () {
    return {
      modalShown: false,
      textVal: ''
    }
  },
  computed: {
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    save: function () {
      this.callbackParams = {'text': this.textVal}
      this.onOk(this.callbackParams)
      this.modalShown = false
    },
    cancel: function () {
      this.onCancel()
      this.modalShown = false
    }
  },
  mounted: function () {
    this.textVal = this.defaultText
  },
  created: function () {
  }
}
</script>
<style src="../../css/list/list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/components/common/InputModal.vue